<!--  -->
<template>
    <div class="messageManage">
        <div class="btn_box">
            <div class="left_btn">
                <el-button @click="messageIssue" type="primary">资讯发布</el-button>
            </div>
            <div class="right_search">
                <el-select v-model="params.status" placeholder="资讯状态">
                    <el-option v-for="(item, index) in messageStatus" :key="index" :label="item.statusname" :value="item.status"></el-option>
                </el-select>
                <el-select v-model="params.topiccolumncode" placeholder="专题分类">
                    <el-option v-for="(item, index) in specialClassify" :key="index" :label="item.name" :value="item.innerid"></el-option>
                </el-select>
                <el-input class="keyname" v-model="params.keyname" placeholder="请输入资讯标题"></el-input>
                <el-button @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="文章标题" class-name="subject_box" width="380px">
                <template slot-scope="scope">
                    <div class="cover_img_subject">
                        <div class="cover_img">
                            <!-- <i class="el-icon-picture" v-if="!scope.row.logourl"></i> -->
                            <img :src="scope.row.logourl" v-if="scope.row.logourl" alt="">
                        </div>
                        <div class="subject">{{scope.row.subject}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="articletypename" class-name="center" label="文章类型"></el-table-column>
            <el-table-column prop="topiccolumnname" class-name="center" label="专题分类">
                <template slot-scope="scope">
                    <span v-if="scope.row.topiccolumnname">{{scope.row.topiccolumnname}}</span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column prop="viewcount" class-name="center" label="浏览量"></el-table-column>
            <el-table-column prop="statusname" class-name="center" label="文章状态">
                <template slot-scope="scope">
                    <span :class="scope.row.status | filterStatus">{{scope.row.statusname}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="releasetime" class-name="center" label="发布时间"></el-table-column>
            <el-table-column label="操作" class-name="right">
                <template slot-scope="scope">
                    <div>
                        <span class="handle" @click="handleEdit(scope.row.innerid)" v-if="scope.row.status === 0 || scope.row.status === 10">编辑</span>
                        <span class="line" v-if="scope.row.status === 0 || scope.row.status === 10">|</span>
                        <span class="handle" @click="handleDelete(scope.row, scope.$index)" v-if="scope.row.status === 0 || scope.row.status === 10">删除</span>
                        <span class="handle" @click="handleCheck(scope.row.innerid)" v-if="scope.row.status === 100">查看</span>
                        <span class="line">|</span>
                        <span class="handle" @click="handleRecommend(scope)" v-if="!scope.row.istop">设为推荐</span>
                        <span class="handle" @click="handleRecommend(scope)" v-else>取消推荐</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page ref="page" @getList="getAllSxytopiccontentinfo" :total="total" />
    </div>
</template>

<script>
import page from '@/base/page/page3'
import {getAllSxytopiccontentinfo, getSxytopiccolumninfo, uploadQuestionbanktopiccontentStatus, uploadSxytopiccontentIstop} from 'api/imageText'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            messageStatus: [
                {status: ' ', statusname: '全部状态'},
                {status: 0, statusname: '草稿'},
                {status: 10, statusname: '已发布'},
                {status: 100, statusname: '已删除'}
            ],
            specialClassify: [],
            params: {
                keyname: '',
                status: '',
                topiccolumncode: ''
            },
            page: {
                page: 1,
                pageSize: 10,
            },
            tableData: [],
            total: 0
        }
    },
    props: ['currenttop'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getAllSxytopiccontentinfo(this.page)
        this.getSxytopiccolumninfo()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleSearch() {
            this.page.page = 1
            this.getAllSxytopiccontentinfo(this.page)
        },
        getAllSxytopiccontentinfo(page) {
            this.setLoading(true)
            const params = JSON.parse(JSON.stringify(this.params))
            if (params.status === ' ') {
                params.status = ''
            }
            if (params.topiccolumncode === ' ') {
                params.topiccolumncode = ''
            }
            getAllSxytopiccontentinfo({
                data: Object.assign({}, page, params, {topiccode: this.currenttop.topiccode}),
                success: res => {
                    console.log(res.data)
                    this.setLoading(false)
                    this.page.page = page.page
                    this.total = res.data.pageinfo.rowCount
                    this.tableData = res.data.content
                    console.log(this.total)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        getSxytopiccolumninfo() {
            this.setLoading(true)
            getSxytopiccolumninfo({
                data: {topiccode: this.currenttop.topiccode},
                success: res => {
                    this.setLoading(false)
                    res.data.content.unshift({name: '全部分类', innerid: ' '})
                    this.specialClassify = res.data.content
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        messageIssue() {
            this.$router.push({
                name: 'MessageIssue',
                query: {
                    topiccode: this.currenttop.topiccode,
                    topicname: this.currenttop.topicname
                }
            })
        },
        handleEdit(innerid) {
            this.$router.push({
                name: 'MessageIssue',
                query: {
                    topiccode: this.currenttop.topiccode,
                    topicname: this.currenttop.topicname,
                    innerid
                }
            })
            console.log(innerid)
        },
        handleDelete(row, index) {
            this.$confirm('确定删除该资讯吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                console.log(row)
                uploadQuestionbanktopiccontentStatus({
                    data: {innerid: row.innerid},
                    success: res => {
                        this.setLoading(false)
                        row.status = 100
                        row.statusname = '已删除'
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {       
            })
        },
        handleCheck(innerid) {
            this.$router.push({
                name: 'MessageIssue',
                query: {
                    topiccode: this.currenttop.topiccode,
                    topicname: this.currenttop.topicname,
                    innerid
                }
            })
        },
        handleRecommend(scope) {
            this.setLoading(true)
            uploadSxytopiccontentIstop({
                data: {innerid: scope.row.innerid, istop: scope.row.istop ? 0 : 1},
                success: res => {
                    this.setLoading(false)
                    if (scope.row.istop) {
                        scope.row.istop = 0
                    } else {
                        scope.row.istop = 1
                    }
                },
                error: res => {
                    this.$message.error(res.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {
        filterStatus(status) {
            let classname = ''
            switch(status) {
                case 0:
                    classname = 'status0'
                break
                case 10:
                    classname = 'status10'
                break
                case 100:
                    classname = 'status100'
                break
            }
            return classname
        }
    },
    components: {
        page
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .messageManage {
        .btn_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
            .left_btn {
                .el-button {
                    width: 110px;
                    height: 40px;
                }
            }
            .right_search {
                display: flex;
                align-items: center;
                .el-select {
                    margin-right: 30px;
                    width: 108px;
                    min-width: 108px;
                    .el-input__icon {
                        line-height: 32px;
                    }
                }
                .keyname {
                    width: 220px;
                    margin-right: 30px;
                }
            }
        }
        .el-table {
            .center {
                .cell {
                    text-align: center;
                }
            }
            .right {
                .cell {
                    text-align: right;
                }
            }
            .handle {
                color: #409EFF;
                font-size: 12px;
                cursor: pointer;
            }
            .line {
                color: #409EFF;
                font-size: 14px;
                margin: 0 5px;
                position: relative;
                top: -1px;
            }
            th.subject_box {
                .cell {
                    padding-left: 125px;
                }
            }
            .cover_img_subject {
                display: flex;
                .cover_img {
                    width: 106px;
                    height: 60px;
                    background: #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    margin-right: 10px;
                    color: #999999;
                    img {
                        width: 106px;
                        height: 60px;
                    }
                }
                .subject {
                    width: 240px;
                    overflow:hidden; 
                    text-overflow:ellipsis;
                    display:-webkit-box; 
                    -webkit-box-orient:vertical;
                    -webkit-line-clamp:2; 
                    text-align: left;
                }
            }
            .status0 {
                color: #606266;
            }
            .status10 {
                color: #67C23A;
            }
            .status100 {
                color: #999999;
            }
        }
    }
</style>